import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { EcommerceGenericoService, Usuario } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { GenericoSlideAnim } from '../etc/generico-animation';
import { MenuMmaxInterface } from '../etc/mmax-menu.interface';
import { MarianomGeneral } from '../marianom-general.service';
import { takeUntil } from 'rxjs/operators';
import { Subject, Subscribable } from 'rxjs';

@Component({
  selector: 'mmax-usuario-budget',
  templateUrl: './usuario-budget-mmax.component.html',
  styleUrls: ['./usuario-budget-mmax.component.scss'],
  animations: [
    GenericoSlideAnim
  ]
})

export class UsuarioBudgetMmaxComponent implements OnInit {
  @Input('mode') modo: string = 'normal';
  @Input() loader: string = 'block';
  @Input() login: string;

  menus: UsuariosBudgetMenu[];
  mobilhome: UsuariosBudgetMenu = {
    nombre: 'home',
    url: '',
    urlmobile: '/app-mobile/home',
    icourl: 'mdi mdi-home'
  };
  usericon: UsuariosBudgetMenu = {
    nombre: 'Método de Pago',
    url: 'metodosdpago',
    icourl: 'mdi mdi-account-circle-outline'
  };
  usuario: Usuario;
  _destroyed$: Subject<any> = new Subject();
  mostrarMetodosPago: boolean = false;

  constructor(private serv: MarianomGeneral, private genServ: EcommerceGenericoService, private modal: ModalService, private route: ActivatedRoute) {
    this.mostrarMetodosPago = this.genServ.mostrarMetodosPago;
    this.menus = [
      {
        nombre: 'Sucursales',
        icourl: 'mdi mdi-store',
        function: 'abrirSucursales'
      },
      {
        nombre: 'Mis Datos',
        url: '/misdatos',
        urlmobile: '/app-mobile/app/account',
        icourl: 'mdi mdi-account-details-outline'
      },
      {
        nombre: 'Mis Compras',
        url: '/historial',
        icourl: 'mdi mdi-clipboard-text-outline'
      },
      ...(this.mostrarMetodosPago ? [{
        nombre: 'Método de Pago',
        url: '/metodosdpago',
        icourl: 'mdi mdi-credit-card-outline',
        function: 'notImplemented'
      }] : []),
      {
        nombre: 'Carrito de Compras',
        url: '/resumendecompra',
        urlmobile: '/app-mobile/cart',
        icourl: 'mdi mdi-cart-arrow-down'
      },
      {
        nombre: 'Ayuda',
        url: '/ayudas',
        urlmobile: '/app-mobile/app/help',
        icourl: 'mdi mdi-help-circle-outline'
      },
      {
        nombre: 'Salir',
        // url: '',
        urlmobile: 'app-mobile/app',
        icourl: 'mdi mdi-logout-variant',
        function: 'salir'
      }
    ];

    this.genServ.returnBeneficios().pipe(takeUntil(this._destroyed$)).subscribe(data => {
      if (data === "S") {
        this.menus.push(
          {
            nombre: 'Beneficios',
            url: '/beneficios',
            icourl: 'mdi mdi-star-outline'
            // function: 'openBeneficios'
          })
      }
    });

    this.loader = this.loader || 'none';
    this.login = this.login || 'none';
    this.genServ.getUsuarioProvider().subscribe(data => {
      this.login = 'flex';
      this.loader = 'none';
      this.usuario = data;
    });
  }

  ngOnInit(): void {
    if (this.loader === 'block') {
      this.login = 'none';
    }
  }

  salir() {
    this.modal.open('modal-salir')
  }

  abrirSucursales() {
    this.modal.open('sucursal-modal-1');
  }

  notImplemented() {
    this.modal.open('modal-no-implemented')
  }

  openBeneficios() {
    window.open("https://beneficios.mmax.com.ar/", '_blank');
  }

  indexWindow(url) {
    if (url != undefined) {
      window.scrollTo(0, 0);
    }
  }

  gotoURL(url: string, nombre: string) {
    if (url === "/resumendecompra") {
      if (this.total === 0) {
        this.modal.open('modal-agregar-producto');
      } else {
        for (let i = 0; i < this.topMenus.length; i++) {
          const element = this.topMenus[i];
          element.activo = false;
        }

        this.serv.gotoURL(url, this.route);
      }
    }
    else {
      for (let i = 0; i < this.topMenus.length; i++) {
        const element = this.topMenus[i];

        if (nombre === element.nombre) {
          this.serv.activatethis(element);
        } else {
          element.activo = false;
        }
      }

      if (url != undefined) {
        this.serv.gotoURL(url, this.route);
      }
    }

  }

  closebudget() {
    this.serv.desplegaryCerrarusu(!this.desplegado);
  }

  ejecutar(funcion) {
    if (funcion != undefined) {
      this[funcion]();
    }

  }

  volverAtras() {
    this.serv.navigator.goLandPage(this.route);
  }

  volverAtrasMobile() {
    this.serv.navigator.goLandPage(this.route);
  }

  startLoginMobile() {
    this.serv.gotoURL('login', this.route);
  }

  loginStart() {
    this.modal.open('login-modal-1');
  }

  get nombreSucursal() {
    let sucursales = this.genServ.getSucursales();
    let sucTrue = false;
    for (let i = 0; i < sucursales.length; i++) {
      const element = sucursales[i];
      if (element.sucursal == this.usuario.sucursal) {

        sucTrue = true;
      }
    }
    if (sucTrue == false) {
      return (" Sin Definir");
    }
    else {
      return this.usuario.sucursalNombre || ' Sin Definir'
    }
  }

  get desplegado() {
    return this.serv.desplegadousa;
  }

  get topMenus(): MenuMmaxInterface[] {
    return this.serv.rutas
  }

  get total() {
    return this.genServ.getCantidadTotal();
  }

}

export interface UsuariosBudgetMenu {
  nombre: string,
  url?: string,
  urlmobile?: string,
  urltablet?: string,
  icourl?: string,
  function?: string,
}
